import { ENDPOINT } from '~/constants';

import { HTTPError, vestigasApi } from '~/services/kyClient';
import ToastService from '~/services/toast.service';

import { i18n, log } from '~/utils';

import {
  type CompanyAliasAddressesResponse,
  type CompanyAliasAddressesSearchParameters,
} from './types';
import {
  zodCompanyAliasAddressesResponseSchema,
  zodCompanyAliasAddressesSearchParametersSchema,
} from './validations';

/**
 * Fetches all company alias addresses from the API.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/VESTIGAS-Admin-Company/operation/get_all_company_addresses_filtered_vadmin_company_alias_address_get
 */
export const fetchCompanyAliasAddresses = async (
  searchParams: CompanyAliasAddressesSearchParameters,
) => {
  try {
    const response = await vestigasApi
      .get(ENDPOINT.COMPANY.ALIAS_ADDRESS.GET_ALL(), {
        searchParams,
        validate: {
          response: zodCompanyAliasAddressesResponseSchema,
          searchParams: zodCompanyAliasAddressesSearchParametersSchema,
        },
      })
      .json<CompanyAliasAddressesResponse>();

    return response;
  } catch (error) {
    log.error({
      message: 'Error fetching company alias addresses',
      error,
    });

    let errorMessage = '';

    if (error instanceof HTTPError) {
      switch (error.response.status) {
        case 422: {
          errorMessage = i18n.t(
            ($) => $.company.fetchCompanyAliasAddresses.error422,
            { ns: 'data' },
          );
          break;
        }

        default: {
          errorMessage = i18n.t(
            ($) => $.company.fetchCompanyAliasAddresses.error.generic,
            { ns: 'data' },
          );
        }
      }
    }

    if (errorMessage) {
      ToastService.error(errorMessage);
    }

    // Re-throw the error to propagate it to the calling function.
    throw error;
  }
};
